////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const logSynchro = {
	postLogSynchro: (filters = {}, queryParams = { page: '0', size: '250', sort: 'dateCreated', nameDir: 'desc' }) => ({
		type: ActionsTypes.POST_LOG_SYNCHRO,
		payload: {
			filters,
			queryParams,
		},
	}),
	postLogSynchroSuccess: (data) => ({
		type: ActionsTypes.POST_LOG_SYNCHRO_SUCCESS,
		payload: { data },
	}),
	postLogSynchroFailure: () => ({
		type: ActionsTypes.POST_LOG_SYNCHRO_FAILURE,
		payload: {},
	}),
	resetLogSynchroItems: () => ({
		type: ActionsTypes.RESET_LOG_SYNCHRO_ITEMS,
	}),
	resetLogSynchro: () => ({
		type: ActionsTypes.RESET_LOG_SYNCHRO,
	}),
}

export default logSynchro
